import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  TextField,
  CircularProgress,
  Typography,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Button
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { captureException } from "@sentry/react";
import api from "src/utils/api";
import getAvatarStyle from "src/utils/getAvatarStyle";
import getInitials from "src/utils/getInitials";
import { useSelector, useDispatch } from "react-redux";
import { toastAction } from "../../../actions";

function AddAccessModal(props) {
  const { open, onClose } = props;
  const dispatch = useDispatch();
  const [suggestionList, setSuggestionList] = useState([]);
  const [loading, setloading] = useState(false);
  const [openSuggestion, setopenSuggestion] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [accessGroups, setAccessGroups] = useState([]);

  const [userId, setuserId] = useState("");
  const [accessGroupId, setaccessGroupId] = useState("");

  const orgSettings = useSelector(state => state.orgSettings);

  useEffect(() => {
    if (!openSuggestion) {
      setSuggestionList([]);
    } else {
      setloading(true);
      (async () => {
        try {
          var data = await api(
            "POST",
            "ble/user/searchUser",
            {
              search: [
                {
                  key: "employee.name",
                  value: searchInput,
                  comparison: "LIKE"
                },
                {
                  key: "bleCards.rosslareUserId",
                  value: -1,
                  comparison: "="
                }
              ],
              sort: {
                key: "employee.name",
                order: "ASC"
              },
              skip: 0,
              take: 10
            },
            true
          );
          setSuggestionList(data);
          setloading(false);
        } catch (error) {
          setloading(false);
          captureException(error);
        }
      })();
    }
  }, [searchInput, openSuggestion]);

  useEffect(() => {
    (async () => {
      try {
        var data = await api(
          "GET",
          "ble/groups/getAllAccessGroups",
          null,
          true
        );
        setAccessGroups(data.data.Data);
      } catch (error) {
        captureException(error);
      }
    })();
  }, []);
  const handleClose = () => {
    onClose();
    setSearchInput("");
    setuserId("");
    setaccessGroupId("");
  };

  const handleSubmit = async () => {
    if (userId === "") {
      dispatch(
        toastAction({
          status: true,
          message: "Please select a user",
          type: "error",
          noIcon: true
        })
      );
      return;
    }

    if (accessGroupId === "") {
      dispatch(
        toastAction({
          status: true,
          message: "Please select an access group",
          type: "error",
          noIcon: true
        })
      );
      return;
    }

    (async () => {
      try {
        await api(
          "POST",
          "ble/user/addWithAccessGroup",
          {
            employeeId: userId,
            rosslareGroupId: accessGroupId
          },
          true
        );
        handleClose();
        dispatch(
          toastAction({
            status: true,
            message: "User added successfully",
            type: "success",
            noIcon: true
          })
        );
      } catch (error) {
        captureException(error);
        dispatch(
          toastAction({
            status: true,
            message: "Something went wrong",
            type: "error",
            noIcon: true
          })
        );
      }
    })();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
      <DialogTitle id="alert-dialog-title"> Add New User</DialogTitle>
      <DialogContent>
        <Autocomplete
          fullWidth
          id="user"
          open={openSuggestion}
          noOptionsText={"No user found"}
          options={suggestionList}
          onOpen={() => {
            setopenSuggestion(true);
          }}
          onClose={() => {
            setopenSuggestion(false);
          }}
          onChange={(event, newValue) => {
            setuserId(newValue.id);
          }}
          getOptionLabel={option => {
            return option.name;
          }}
          renderOption={item => {
            return (
              <ListItem dense disableGutters className="suggestedParticipant">
                <ListItemAvatar>
                  <Avatar style={getAvatarStyle(item.email)}>
                    {getInitials(item.inputValue ? "+" : item.name)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography variant="h5">{item.name}</Typography>}
                  secondary={
                    <Typography variant="body2" color="textSecondary">
                      {item.role && item[orgSettings.employeePrimaryIdentifier]}
                      {!item.role && item[orgSettings.visitorPrimaryIdentifier]}
                    </Typography>
                  }
                />
              </ListItem>
            );
          }}
          renderInput={params => (
            <TextField
              {...params}
              label={"Search user by name"}
              variant="outlined"
              onChange={e => setSearchInput(e.target.value)}
              value={searchInput}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                )
              }}
            />
          )}
        />
        <br />
        <FormControl variant="outlined" style={{ width: "100%" }}>
          <InputLabel id="accessGroup">Access Group</InputLabel>
          <Select
            labelId="accessGroup"
            id="accessGroupDropdown"
            label="Access Group"
            value={accessGroupId}
            onChange={e => {
              setaccessGroupId(e.target.value);
            }}
            autoWidth
          >
            {accessGroups.map(group => {
              return (
                <MenuItem key={group.ID} value={group.ID}>
                  {group.tDesc}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Skip
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddAccessModal;
